import { requestType } from '~/config/enum.config';
var SERVICE = 'dataimp-service';
var CONTROLLER = 'labelingStrategyController';
export default {
    /**
     * 打标队列查询
     */
    queryLabelingStrategy: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryLabelingStrategy',
        type: requestType.Get
    },
    /**
     * 保存打标队列
     */
    saveLabelingStrategy: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'saveLabelingStrategy',
        type: requestType.Post
    },
    /**
     * 查询出一条打标队列，用作查看或编辑
     */
    findOneLabelingStrategy: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'findOneLabelingStrategy',
        type: requestType.Get
    },
    /**
     * 获取支持的策略字段
     */
    getLabelFields: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getLabelFields',
        type: requestType.Get
    },
    /**
     * 执行记录查看，根据队列id查询该队列全部汇总记录
     */
    queryLabelDetailAll: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryLabelDetailAll',
        type: requestType.Get
    },
    /**
     * 执行记录明细查看
     */
    queryLabelDetailData: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryLabelDetailData',
        type: requestType.Get
    },
    /**
     * 获取Label标签数据
     */
    getLabelNameList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getLabelNameList',
        type: requestType.Get
    },
    /**
     * 作废/终止
     */
    updateLabelStatus: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'updateLabelStatus',
        type: requestType.Get
    },
    /**
     * 手动执行催收队列
     */
    manualLabel: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'manualLabel',
        type: requestType.Get
    }
};
